import { HIDE_OVERLAYS } from "core-web/state/models/Overlay/constants";
import store from "core-web/state/store";

export const hideOverlays =
    (dataToKeep = null) =>
    (dispatch) => {
        dispatch({ type: HIDE_OVERLAYS, data: dataToKeep });
    };

export default (dataToKeep) => store.dispatch(hideOverlays(dataToKeep));
